export default "__VITE_ASSET__BAqd2Vf3__"